module.exports = __webpack_public_path__ + "44f49f347b463a2ac9ae04bdeffa7be4.svg";